import React from "react";
import DocentesView from "./pages/DocentesView";

export default function Docentes() {
  return <DocentesView />;
}
